module.exports = __webpack_public_path__ + "img/38-MRD.d4074b6.jpg";